import { useSearchParams } from 'react-router-dom';
import DepositPage from '../Deposit/DepositPage';
import SelectParcelPage from '../SelectParcel/SelectParcelPage';

export default function DepositTutorialPage() {
  const [searchParams] = useSearchParams();
  return searchParams.get('type') ? <DepositPage /> : <SelectParcelPage />;
}
